import { render, staticRenderFns } from "./EditBank.vue?vue&type=template&id=495fe42e&scoped=true"
import script from "./EditBank.vue?vue&type=script&lang=js"
export * from "./EditBank.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "495fe42e",
  null
  
)

export default component.exports